import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeUrlHelper } from '@sc/pas-common';
var SupportPasComponent = /** @class */ (function () {
    function SupportPasComponent(urlHelper, router) {
        this.urlHelper = urlHelper;
        this.router = router;
    }
    SupportPasComponent.prototype.ngOnInit = function () {
        this.GoToSoportePas();
        this.router.navigate(['inicio']);
    };
    SupportPasComponent.prototype.GoToSoportePas = function () {
        var url = this.urlHelper.getUrlSoportePas('siniestros');
        window.open(url, '_blank');
    };
    return SupportPasComponent;
}());
export { SupportPasComponent };
